"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = decodeFlagValues;
function decodeFlagValues({ flagPaths, encodedValues, }) {
    const flagValues = JSON.parse(atob(encodedValues));
    const missingFlags = flagPaths.filter((flag) => !(flag in flagValues));
    if (missingFlags.length > 0) {
        throw new Error(`Missing flag values for: ${missingFlags.join(", ")}`);
    }
    return flagValues;
}
//# sourceMappingURL=decodeFlagValues.js.map